import WebAPI from './WebAPI'
import store from '@/store'

const API_ROOT_PERMISSION = process.env.API_ROOT_XANDR_NODE

/**
 * Look at the Confluence API article for more information
 * https://audiencematters.atlassian.net/wiki/spaces/AM/pages/332103681/User+Permissions
 */
class PermissionsAPI extends WebAPI {
  constructor () {
    super({baseURL: API_ROOT_PERMISSION})
  }

  getCategories () {
    return this.__get({extensionURL: '/Permissions/Categories'})
  }

  getCategoryHierarchy (id) {
    return this.__get({extensionURL: `/Permissions/Hierarchy/${id}`})
  }

  upsertCategory (category) {
    return this.__post({extensionURL: '/Permissions/Category', payload: {category}})
  }

  getPermissions () {
    return this.__get({extensionURL: '/Permissions'})
  }

  upsertPermission (permission) {
    return this.__post({extensionURL: '/Permissions', payload: {permission}})
  }

  getRoles () {
    return this.__get({extensionURL: '/Permissions/Roles'})
  }

  upsertRole (role) {
    return this.__post({extensionURL: '/Permissions/Roles', payload: {role}})
  }

  deleteRole (id) {
    return this.__delete({ extensionURL: `/Permissions/Roles/${id}` })
  }

  getUsers () {
    return this.__get({extensionURL: '/Permissions/Users'})
  }

  upsertUser (user) {
    // added for IDM tokens
    let IDMToken = store.state.idmAuth.token
    return this.__post({extensionURL: '/Permissions/Users', payload: {user, IDMToken}})
  }

  deleteUser (id) {
    return this.__delete({ extensionURL: `/Permissions/Users/${id}` })
  }
}

export default new PermissionsAPI()



// WEBPACK FOOTER //
// ./src/app/api/PermissionsAPI.js